import { render, staticRenderFns } from "./DataLoad.vue?vue&type=template&id=7d968c60&scoped=true&"
import script from "./DataLoad.vue?vue&type=script&lang=js&"
export * from "./DataLoad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d968c60",
  null
  
)

export default component.exports